import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';

import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';
import { loadLogRollbackVersionFailed, loadLogRollbackVersionSuccessful } from '../actions';

export default function* loadLogRollbackVersion(action) {
  try {
    const url = `${BACKEND_URL_V2}/audit/rollback-plans/${action.payload}/logs`;
    const dataResponse = yield makeRequest(url, { limit: 50 }, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadLogRollbackVersionSuccessful(data.data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadLogRollbackVersionFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadLogRollbackVersionFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
